import * as React from 'react';

const SvgClockOutlined = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 25"
		width="1em"
		height="1em"
		{...props}
	>
		<path
			fill="#60636B"
			fillRule="evenodd"
			d="M3.719 12.76a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0m8.25-9.75c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.366 9.75-9.75-4.366-9.75-9.75-9.75m.75 3.75a.75.75 0 0 0-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 0 0 0-1.5h-3.65a.1.1 0 0 1-.1-.1z"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgClockOutlined;
